/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useTheme } from '@mui/material';
import AnalyticsWebsiteVisits from 'src/sections/overview/analytics/analytics-website-visits';

const TopProjectsChart: React.FC = () => {
  const theme = useTheme();
  return (
    <>
      <div>
        <AnalyticsWebsiteVisits
          title="FY 2024 Top 5 Projects"
          chart={{
            labels: ['Impravata', 'Firewall Upgrade', 'Keytronic', 'HIM Integrations', 'Handhelds'],
            series: [
              {
                name: '2024',
                type: 'column',
                fill: 'solid',
                data: [95000, 27000, 20750, 42500, 35000],
              }
            ],
          }}
        />
      </div>
    </>
  );
};

export default TopProjectsChart;
